import { Input } from 'components/Input/Input';

import { Field } from './Field/Field';

type Props = {
  name: string;
  label?: string;
  description?: string;
  message?: string;
  'aria-label'?: string;
  'data-qa-id'?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onUpdateValue?: (...args: Array<any>) => any;
  accept?: string;
  placeholder?: string;
  id?: string;
  disabled?: boolean;
  type: 'URL' | 'FILE';
};

export function RequestedURLUserField({
  name,
  label,
  description,
  onUpdateValue,
  disabled,
  'data-qa-id': qaId,
  type,
  ...props
}: Props) {
  if (type !== 'URL') return null;
  const subName = `${name}.${type.toLowerCase()}`;

  return (
    <Field
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      customErrorMatch={(errors) => errors[name] || errors[subName]}
      name={name}
      label={label}
      description={description}
      inputProps={props}
      renderInput={({ value, qaId: autoQaId, updateValue }) => (
        <Input
          inputProps={{
            disabled,
            id: props.id,
            name,
            placeholder: props.placeholder,
            qaId: `${qaId || autoQaId}-hidden-input`,
            value: value ? value.url : '',
            type: 'text',
            onChange: (e) => {
              const v = e.target.value;

              if (onUpdateValue) {
                onUpdateValue(
                  v
                    ? {
                        type: 'URL',
                        url: v,
                      }
                    : null,
                );
              } else {
                updateValue(
                  v
                    ? {
                        type: 'URL',
                        url: v,
                      }
                    : null,
                );
              }
            },
          }}
        />
      )}
    />
  );
}
